import { render } from "./PDFPreviewerDialog.vue?vue&type=template&id=27c087df&scoped=true"
import script from "./PDFPreviewerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFPreviewerDialog.vue?vue&type=script&setup=true&lang=js"

import "./PDFPreviewerDialog.vue?vue&type=style&index=0&id=27c087df&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c087df"],['__file',"src/components/dialogs/PDFPreviewerDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27c087df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27c087df', __exports__)) {
    api.reload('27c087df', __exports__)
  }
  
  module.hot.accept("./PDFPreviewerDialog.vue?vue&type=template&id=27c087df&scoped=true", () => {
    api.rerender('27c087df', render)
  })

}


export default __exports__